import React, { Fragment } from 'react';
import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import { Spotlight } from '@atlaskit/onboarding';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation';
import { useConversationAssistantSpotlightActions, useConversationAssistantSpotlightState } from '../../controllers/spotlight';
import { SPOTLIGHT_ONBOARDING_TARGET } from './constants';
import messages from './messages';
export var ConversationAssistantOnboardingSpotlight = function ConversationAssistantOnboardingSpotlight(_ref) {
  var openRovoChat = _ref.openRovoChat,
    openAgentSelectorMenu = _ref.openAgentSelectorMenu,
    onDismiss = _ref.onDismiss;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useConversationAssis = useConversationAssistantSpotlightActions(),
    end = _useConversationAssis.end;
  var _useConversationAssis2 = useConversationAssistantSpotlightState(),
    activeSpotlight = _useConversationAssis2.activeSpotlight;
  var _useAnalytics = useAnalytics(),
    sendAnalyticsEvent = _useAnalytics.sendAnalyticsEvent;
  var renderActiveSpotlight = function renderActiveSpotlight() {
    var spotlights = [/*#__PURE__*/React.createElement(Spotlight, {
      actions: [{
        onClick: function onClick(event, analyticsEvent) {
          if (openRovoChat) {
            openRovoChat(event, analyticsEvent);
          }
          end();
          onDismiss();
          sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissed',
            actionSubject: 'rovoChatButtonSpotlight'
          });
        },
        text: formatMessage(messages.tryChat)
      }],
      heading: formatMessage(messages.onboardingHeading),
      target: SPOTLIGHT_ONBOARDING_TARGET,
      key: SPOTLIGHT_ONBOARDING_TARGET,
      targetRadius: 3
    }, formatMessage(messages.onboardingDescription))];
    if (activeSpotlight === null) {
      return null;
    }
    return spotlights[activeSpotlight];
  };
  return /*#__PURE__*/React.createElement(Fragment, null, renderActiveSpotlight());
};